import memoizeOne from "memoize-one";
import { roundValue } from "lib/number";
import { MetricsKind } from "../types";
import { MergedColumnFormulaOptions } from "./types";
import { ValueGetterParams } from "ag-grid-community";
import { loopGridNode, referenceMetricValueOrCompute } from "../sibling-value-getter";
import { getChildrenUnits } from "./units";

/**
 * Get aggregrated total units of the entire column. Loop through all row nodes and sum their values.
 */
const getColumnTotalUnit = memoizeOne(
    (options: MergedColumnFormulaOptions, valueGetterParams: ValueGetterParams) => {
        let totalUnits = 0;
        loopGridNode(valueGetterParams.api, (childNode) => {
            const childGetterParams = {
                ...valueGetterParams,
                node: childNode,
                data: childNode.data,
            };
            const units = referenceMetricValueOrCompute(
                () => getChildrenUnits(options, childGetterParams),
                childGetterParams,
                MetricsKind.UNITS
            );
            totalUnits += units;
        });

        return totalUnits;
    },
    (newArgs, oldArgs) =>
        newArgs[1].colDef.colId === oldArgs[1].colDef.colId && newArgs[1].node.id === oldArgs[1].node.id
);

export const UNIT_ROW_PERCENTAGE_PLAN = (
    _values: number[],
    options: MergedColumnFormulaOptions,
    gridGetterParams: ValueGetterParams
) => {
    const unitsValue = referenceMetricValueOrCompute(
        () => getChildrenUnits(options, gridGetterParams),
        gridGetterParams,
        MetricsKind.UNITS
    );

    // Bail out sooner. No point doing heavy calculation of the whole rows if current value is 0.
    if (!unitsValue) {
        return 0;
    }

    const totalUnits = getColumnTotalUnit(options, gridGetterParams);

    return totalUnits > 0 ? roundValue((unitsValue / totalUnits) * 100, options.decimal) : 0;
};
